import React from "react";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import cellEditFactory from "react-bootstrap-table2-editor";
import { useTranslation } from "react-i18next";
import { numbersAndDot } from "../../../../../Config/Regex";

const ArticlesTable = ({
  products,
  setProducts,
  quantityMsg,
  setQuantityMsg,
}) => {
  const { t: translator } = useTranslation();
  const { SearchBar } = Search;

  const options = {
    sizePerPage: 5,
    hideSizePerPage: true,
    hidePageListOnlyOnePage: true,
  };

  function currencyFormatter(cell) {
    return new Intl.NumberFormat("hr", {
      style: "currency",
      currency: "EUR",
    }).format(Number(cell));
  }

  function actionFormatter(cell, row) {
    return (
      <div className="action">
        <span className="icon icon-cancel" style={{ color: "#c00" }}></span>
      </div>
    );
  }

  const columns = [
    {
      dataField: "productGuid",
      text: "",
      headerStyle: (colum, colIndex) => {
        return { width: "50px", textAlign: "center" };
      },
      formatter: actionFormatter,
      searchable: false,
      events: {
        onClick: (e, column, columnIndex, row, rowIndex) => {
          setProducts(
            products.filter((item) => item.productGuid !== row.productGuid)
          );
        },
      },
    },
    {
      dataField: "productName",
      text: translator("InitialState-Product"),
      editable: false,
    },
    {
      dataField: "price",
      text: translator("InitialState-Price"),
      formatter: currencyFormatter,
      editable: false,
      searchable: false,
    },
    {
      dataField: "quantity",
      text: `${translator("InitialState-Quantity")}*`,
      searchable: false,
      validator: (newValue, row, column) => {
        if (
          isNaN(newValue) ||
          newValue == "" ||
          !numbersAndDot.test(newValue)
        ) {
          return {
            valid: false,
            message: translator("QuantityNumberMsg"),
          };
        }
        if (newValue < 0) {
          return {
            valid: false,
            message: translator("QuantityNotNegative"),
          };
        }

        if (newValue >= 100000) {
          return {
            valid: false,
            message: translator("QuantityMaxThousand"),
          };
        }
        setQuantityMsg("");
        return true;
      },
    },
  ];

  return (
    <ToolkitProvider
      keyField="productGuid"
      data={products}
      columns={columns}
      search
    >
      {(props) => (
        <>
          <div className="form-group">
            <SearchBar
              {...props.searchProps}
              placeholder={translator("Search")}
              className="col-md-12"
            />
          </div>

          <hr />
          <span className="text-danger">{translator(quantityMsg)}</span>
          <BootstrapTable
            {...props.baseProps}
            noDataIndication={translator("No-Data")}
            pagination={paginationFactory(options)}
            cellEdit={cellEditFactory({
              mode: "click",
              blurToSave: true,
            })}
          />
          <p>
            <span className="editableColumns">*</span>
            {translator("EditableTableColumns")}
          </p>
        </>
      )}
    </ToolkitProvider>
  );
};

export default ArticlesTable;
